import $ from 'jquery';
import { scrollToId } from './scrollTo';
import * as pagination from './pagination';
import * as loader from './loader';

export const init = async ($target) => {
	const $jsCareersFilter = $('.js-careers-filter');

	// check if we are on the careers page
	if (!$jsCareersFilter.length) {
		return;
	}

	///////////////////////////////////////////////////////////////////////////////
	/// CONSTANTS AND VARIABLES
	///////////////////////////////////////////////////////////////////////////////

	const PAGE_SIZE = 10,
		JOB_TYPE_STUDENT = 'STUDENT',
		JOB_TYPE_ABSOLVENT = 'ABSOLVENT',
		JOB_TYPE_AGENCY = 'AGENCY',
		JOB_TYPE_EGD = 'EGD',
		SPECIALIZATION_URI_KEY = 'specializationId',
		LOCALITY_URI_KEY = 'localityId';

	const jobTypeCode2IconMappings = {
		[JOB_TYPE_ABSOLVENT]: 'light-bulb',
		[JOB_TYPE_STUDENT]: 'student',
		[JOB_TYPE_AGENCY]: 'agency',
		[JOB_TYPE_EGD]: 'egd',
	};

	const POSITIONS_URL = $jsCareersFilter.data('url-positions'),
		FILTERS_URL = $jsCareersFilter.data('url-filters'),
		REDIRECT_URL = $jsCareersFilter.data('url-redirect'),
		ALL_SPECIALIZATIONS_TEXT = $jsCareersFilter.data('all-specializations'),
		ALL_LOCALITIES_TEXT = $jsCareersFilter.data('all-localities'),
		LINK_TARGET = $jsCareersFilter.data('new-tab') ? '_blank' : '_self',
		JOBS_TITLE_ID = '#jobs-title';

	const dropdownsParent = '.hero .sticky-component__wrap',
		specializationDropdown = dropdownsParent + ' .dropdown:first',
		specializationDropdownSelect = dropdownsParent + ' .dropdown__inner-text:first',
		localityDropdown = dropdownsParent + ' .dropdown:last',
		localityDropdownSelect = dropdownsParent + ' .dropdown__inner-text:last',
		jsCareersTbody = '.js-careers-jobs-tbody';

	const isRedirectVariant = $('.js-careers-filter--redirect').length,
		$searchBtn = $jsCareersFilter.find('.btn'),
		$studentCheckbox = $('.jobs__filter-checkbox input:checkbox'),
		$loader = $('.jobs__table-wrap .js-loader');

	let specializationName2IdMappings = {},
		specializationId2NameMappings = {},
		localityName2IdMappings = {},
		localityId2NameMappings = {},
		jobTypeCode2NameMappings = {},
		uriQueryMappings = {};

	///////////////////////////////////////////////////////////////////////////////
	/// INITIALIZATION
	///////////////////////////////////////////////////////////////////////////////

	await initSearchBox();

	if (!isRedirectVariant) {
		if (uriQueryMappings['hasParams']) scrollToId(JOBS_TITLE_ID);

		initPagination();

		searchPositions(1, false);
	}

	/**
	 * Initializes the sticky search box.
	 */
	async function initSearchBox() {
		const res = await downloadFilters([], []);

		// init mappings
		initMappings(res.SpecializationList, res.LocalityList, Object.values(res.TypeList));

		// update dropdown list
		updateDropdown(specializationDropdown, res.SpecializationList, false);
		updateDropdown(localityDropdown, res.LocalityList, false);
		$target.trigger('contentload');

		let selectedSpecializationName = ALL_SPECIALIZATIONS_TEXT;
		let selectedLocalityName = ALL_LOCALITIES_TEXT;

		if (!isRedirectVariant) {
			// select dropdown items from URI
			selectedSpecializationName = specializationId2Name(uriQueryMappings[SPECIALIZATION_URI_KEY]);
			selectedLocalityName = localityId2Name(uriQueryMappings[LOCALITY_URI_KEY]);
		}

		selectDropdownItemByName(specializationDropdown, selectedSpecializationName);
		selectDropdownItemByName(localityDropdown, selectedLocalityName);

		initSearchBoxCallbacks();
	}

	function initPagination() {
		pagination.init(JOBS_TITLE_ID, onPaginationChange);
		pagination.show();

		function onPaginationChange(page) {
			searchPositions(page, true);
		}
	}

	function initSearchBoxCallbacks() {
		// search button callback
		$searchBtn.on('click', function () {
			if (isRedirectVariant) {
				const specializationId = getSelectedSpecializationIdList()[0];
				const localityId = getSelectedLocalityIdList()[0];

				const url = `${REDIRECT_URL}?${SPECIALIZATION_URI_KEY}=${specializationId}&${LOCALITY_URI_KEY}=${localityId}`;
				window.open(url, LINK_TARGET);
			} else {
				searchPositions(1, false);
				scrollToId(JOBS_TITLE_ID);
			}
		});

		// students/absolvents checkbox callback
		$studentCheckbox.on('change', function () {
			searchPositions(1, false);
		});

		attachDropdownOnChangeCallback(specializationDropdown, specializationOnChangeCallback);
		attachDropdownOnChangeCallback(localityDropdown, localityOnChangeCallback);
	}

	async function searchPositions(page, preventDataLayerPush) {
		const specializationIdList = getSelectedSpecializationIdList();
		const localityIdList = getSelectedLocalityIdList();
		const jobTypeList = getJobTypeList();

		loader.show($loader);

		let response = '';
		try {
			response = await downloadPositions(page, specializationIdList, localityIdList, jobTypeList);
		} catch (err) {
			if (err.status !== '404') console.error('There seems to be an error with the API');
		}

		fillJobsTable(response.PositionLists);

		const totalPages = Math.max(1, Math.ceil(parseInt(response.Count) / PAGE_SIZE));
		pagination.update(page, totalPages);

		loader.hide($loader);

		if (preventDataLayerPush) {
			return;
		}

		try {
			pushDataLayer(specializationIdList, localityIdList, jobTypeList, response);
		} catch (err) {
			console.error('Could not push data layer: ' + err);
		}
	}

	///////////////////////////////////////////////////////////////////////////////
	/// FILTERS
	///////////////////////////////////////////////////////////////////////////////

	function pushDataLayer(specializationIdList, localityIdList, jobTypeList, response) {
		const jobFields = specializationIdList.map((id) => specializationId2NameMappings[id]);
		const regions = localityIdList.map((id) => localityId2NameMappings[id]);

		const dataLayerObject = {
			event: 'internalSearchResult',
			internalSearchType: 'jobListingsSearch',
			internalSearchResults: response.Count,
			internalSearchFilters: {
				jobFields: jobFields,
				regions: regions,
				applicants: jobTypeList,
			},
		};

		dataLayer.push(dataLayerObject);
	}

	/**
	 * Updates the dropdown with the given list of values.
	 *
	 * @param {string} dropdown Dropdown class
	 * @param {Object} list List of dropdown values
	 * @param {boolean=false} registerCallbacks If true, attaches on dropdown change callbacks
	 * @param {string=null} selectedItemName If not null, the dropdown item with this name is selected
	 */
	function updateDropdown(dropdown, list, registerCallbacks = true, selectedItemName = null) {
		// reset
		resetDropdownCallbacks();

		// sort list in ascending order by Id
		list.sort((item1, item2) => parseInt(item1.Id) - parseInt(item2.Id));

		// update HTML
		updateDropdownHTML(dropdown, list);

		if (!registerCallbacks) {
			return;
		}

		// register callbacks
		$target.trigger('contentload');

		if (!!selectedItemName) selectDropdownItemByName(dropdown, selectedItemName);

		attachDropdownOnChangeCallback(specializationDropdown, specializationOnChangeCallback);
		attachDropdownOnChangeCallback(localityDropdown, localityOnChangeCallback);
	}

	async function downloadFilters(specializationIdList, localityIdList) {
		const reqBody = {
			Company: [],
			Type: [],
			SpecializationId: specializationIdList,
			LocalityId: localityIdList,
		};

		try {
			let res = await $.ajax({
				type: 'POST',
				url: FILTERS_URL,
				contentType: 'text/plain',
				data: JSON.stringify(reqBody),
			});

			res.SpecializationList.push({
				Id: 0,
				Name: [ALL_SPECIALIZATIONS_TEXT],
			});

			res.LocalityList.push({
				Id: 0,
				Name: [ALL_LOCALITIES_TEXT],
			});

			return res;
		} catch (err) {
			if (err.status !== '404') console.error('There seems to be an error with the API');
			return null;
		}
	}

	async function specializationOnChangeCallback(event) {
		const idList = specializationName2IdList(event.target.value);
		const res = await downloadFilters(idList, []);

		updateDropdown(localityDropdown, res.LocalityList, true, getSelectedLocalityName());
	}

	async function localityOnChangeCallback(event) {
		const idList = localityName2IdList(event.target.value);
		const res = await downloadFilters([], idList);

		updateDropdown(specializationDropdown, res.SpecializationList, true, getSelectedSpecializationName());
	}

	function attachDropdownOnChangeCallback(dropdown, onChangeCallback) {
		const dropdownSelect = $(dropdown + ' input[name=dropdownSelect]:first');
		dropdownSelect.on('change', onChangeCallback);
	}

	function resetDropdownCallbacks() {
		$('.dropdown').off();
		$('.dropdown *').off();
	}

	function selectDropdownItemByName(dropdown, name) {
		$(dropdown + ' .dropdown__link')
			.filter(function () {
				return $(this).text() === name;
			})
			.trigger('click')
			.trigger('click');
	}

	function updateDropdownHTML(dropdown, list) {
		const dropdownHTML = list
			.map(
				(item) =>
					`<li class="dropdown__item js-dropdown-item" role="option" tabindex="-1">
						<span class="dropdown__link js-dropdown-link">${item.Name}</span>
					</li>`,
			)
			.join('');
		$(dropdown + ' .dropdown__list').html(dropdownHTML);
	}

	///////////////////////////////////////////////////////////////////////////////
	/// JOB POSITIONS
	///////////////////////////////////////////////////////////////////////////////

	async function downloadPositions(page, specializationListId, localityListId, jobTypeList) {
		const reqBody = {
			Page: page,
			PerPage: PAGE_SIZE,
			ShowList: false,
			Company: [],
			Type: jobTypeList,
			SpecializationId: specializationListId,
			LocalityId: localityListId,
		};

		return $.ajax({
			type: 'POST',
			url: POSITIONS_URL,
			contentType: 'text/plain',
			data: JSON.stringify(reqBody),
		});
	}

	function getJobTypeIconHTML(typeCode) {
		const iconName = jobTypeCode2IconMappings[typeCode];
		const typeName = jobTypeCode2NameMappings[typeCode];

		if (iconName === undefined || typeName === undefined) return null;

		const iconText = `
			<span class="jobs__icon">
				<span class="icon-svg icon-svg--${iconName}" aria-hidden="true">
					<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
						<use xlink:href="/img/bg/icons-svg.svg#icon-${iconName}" width="100%" height="100%" focusable="false"></use>
					</svg>
				</span>
				<span class="jobs__icon-name">${typeName}</span>
			</span>`;

		return iconText;
	}

	function fillJobsTable(jobs) {
		const tableBody = jobs.map(
			(job) =>
				`<tr>
					<td>
						<p class="jobs__wrap">
							<a href=${job.Url} class="jobs__link" target="_blank" rel="noopener noreferrer">${job.JobName}</a>
							<span class="jobs__icons">${job.Type.map((jobTypeCode) => getJobTypeIconHTML(jobTypeCode)).join('')}</span>
						</p>
					</td>
					<td>
						<span class="item-icon">
							<span class="item-icon__icon">
								<span class="icon-svg icon-svg--user" aria-hidden="true">
									<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
										<use xlink:href="/img/bg/icons-svg.svg#icon-user" width="100%" height="100%" focusable="false"></use>
									</svg>
								</span>
							</span>
							<span class="item-icon__text">${job.Specialization.join(', ')}</span>
						</span>
					</td>
					<td>
						<span class="item-icon">
							<span class="item-icon__icon">
								<span class="icon-svg icon-svg--location" aria-hidden="true">
									<svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
										<use xlink:href="/img/bg/icons-svg.svg#icon-location" width="100%" height="100%" focusable="false"></use>
									</svg>
								</span>
							</span>
							<span class="item-icon__text">${job.Locality.join(', ')}</span>
						</span>
					</td>
				</tr>`,
		);

		$(jsCareersTbody).html(tableBody);
	}

	///////////////////////////////////////////////////////////////////////////////
	/// UTILS
	///////////////////////////////////////////////////////////////////////////////

	function getJobTypeList() {
		const isStudentCheckboxSelected = $studentCheckbox.prop('checked');
		return isStudentCheckboxSelected ? [JOB_TYPE_STUDENT, JOB_TYPE_ABSOLVENT] : [];
	}

	function getSelectedSpecializationName() {
		return $(specializationDropdownSelect).text();
	}

	function getSelectedSpecializationIdList() {
		return specializationName2IdList(getSelectedSpecializationName());
	}

	function getSelectedLocalityName() {
		return $(localityDropdownSelect).text();
	}

	function getSelectedLocalityIdList() {
		return localityName2IdList(getSelectedLocalityName());
	}

	function specializationId2Name(id) {
		const name = specializationId2NameMappings[id];

		return name !== undefined ? name : ALL_SPECIALIZATIONS_TEXT;
	}

	function specializationName2IdList(name) {
		const id = specializationName2IdMappings[name];

		if (id === undefined) {
			console.error(`Id for specialization ${name} not found!`);
			return [];
		}

		if (id === 0) {
			// all specializations
			return [];
		}

		return [id];
	}

	function localityId2Name(id) {
		const name = localityId2NameMappings[id];

		return name !== undefined ? name : ALL_LOCALITIES_TEXT;
	}

	function localityName2IdList(name) {
		const id = localityName2IdMappings[name];

		if (id === undefined) {
			console.error(`Id for locality ${name} not found!`);
			return [];
		}

		if (id === 0) {
			// all localities
			return [];
		}

		return [id];
	}

	/**
	 * Stores all possible filter values, initializes job type to icon mappings,
	 * and loads the search query parameters.
	 */
	function initMappings(specializationList, localityList, typeList) {
		// specializations
		specializationList.forEach(function (specialization) {
			specializationName2IdMappings[specialization.Name] = specialization.Id;
			specializationId2NameMappings[specialization.Id] = specialization.Name;
		});

		// localities
		localityList.forEach(function (locality) {
			localityName2IdMappings[locality.Name] = locality.Id;
			localityId2NameMappings[locality.Id] = locality.Name;
		});

		// job type names
		typeList.forEach(function (type) {
			jobTypeCode2NameMappings[type.Code] = type.Name;
		});

		// uri query params
		const searchParams = new URLSearchParams(window.location.search);

		const specializationUriValue = searchParams.get(SPECIALIZATION_URI_KEY);
		if (!!specializationUriValue) {
			uriQueryMappings[SPECIALIZATION_URI_KEY] = specializationUriValue;
			uriQueryMappings['hasParams'] = true;
		}

		const localityUriValue = searchParams.get(LOCALITY_URI_KEY);
		if (!!localityUriValue) {
			uriQueryMappings[LOCALITY_URI_KEY] = localityUriValue;
			uriQueryMappings['hasParams'] = true;
		}
	}
};
